module.exports = __webpack_public_path__ + "img/34.fixed_lightning.46a422f3.svg";